import React from "react";
import {
  FormControlLabel,
  Typography,
  Checkbox,
  FormGroup
} from "@material-ui/core";

function AdYn(props) {
  const classes = props.useStyles();
  return (
    <>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.smsYn}
              onChange={e => {
                props.onChangeSmsYn(e.target.checked);
              }}
              name="smsYn"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [선택] SMS 정보 수신
            </Typography>
          }
        />
      </FormGroup>
      <hr />
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.kakaoYn}
              onChange={e => {
                props.onChangeKakaoYn(e.target.checked);
              }}
              name="kakaoYn"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [선택] 카카오 정보 수신
            </Typography>
          }
        />
      </FormGroup>
      <hr />
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.adYn}
              onChange={e => {
                props.onChangeAdYn(e.target.checked);
              }}
              name="adYn"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [선택] 영리목적 광고성 정보 수신
            </Typography>
          }
        />
      </FormGroup>
    </>
  );
}
export default AdYn;
